<template>
<v-card class='elevation-0' >
  <vuex-loader :request-id='reqId' ></vuex-loader>
    <v-card-title class='overline'>
      Are you sure you want to cancel this appointment?
      <v-spacer></v-spacer>
      <v-progress-circular
        v-if='appointmentRequest.loading'
        size='20' width='2' class='mr-2'
        indeterminate color='amber' >
      </v-progress-circular>
    </v-card-title>
    <v-card-text>
      <v-list class='elevation-4 mb-4 pa-0' subheader dense three-line >
        <v-subheader class='overline grey lighten-4 py-0' >Appointment details:</v-subheader>
        <v-divider></v-divider>
        <appointment-list-item :with-action='false' :appointment='appointment' ></appointment-list-item>
      </v-list>
      <v-layout>
        <v-checkbox class='pa-0 ma-0'
          :disabled='!hasContacts'
          :hint='sendCommsHint'
          :persistent-hint='!hasContacts'
          label="Send a message to the customer?"
          v-model="withCommunication" light>
        </v-checkbox>
        <v-btn v-if='appointmentDetail && appointmentDetail.contact_phone'
          small outlined outline color='success'
          :href="whatsappIt(appointmentDetail.contact_phone, cancelMessage)"
          target='_blank' >
          WhatsApp
          <v-icon small >open_in_new</v-icon>
        </v-btn>
      </v-layout>
      <template v-if='withCommunication' >
        <small class='overline' >Contact details:</small>
        <v-chip outline
          v-if='appointmentDetail.contact_phone'
          color='primary'
          class='v-chip--x-small' >{{appointmentDetail.contact_phone}}</v-chip>
        <v-chip
          v-if='appointmentDetail.contact_phone'
          outline
          color='primary'
          class='v-chip--x-small' >{{appointmentDetail.contact_email}}</v-chip>
        <v-checkbox persistent-hint
          label="Include link to book a new appointment"
          hint='Will include a link to your booking widget so that they can schedule a new appointment'
          v-model="withBookingLink" light>
        </v-checkbox>
      </template>
      <v-divider class='mt-2' ></v-divider>
      <v-layout row>
        <v-flex xs8 sm9 md10 lg11 >
          <v-text-field
            v-model='price'
            @click:prepend='toggleClearPrice'
            :prepend-icon="clearpriceIcon"
            :prefix='appointment.currency'
            type="number" label='Clear codes and set new price'>
          </v-text-field>
        </v-flex>
        <v-flex xs4 sm3 md2 lg1 >
          <v-btn :disabled='!clearprice' small outline block class='ml-2 mt-4' @click='price=0' >Set Zero</v-btn>
        </v-flex>
      </v-layout>
      <v-text-field persistent-hint
        :prepend-icon="withInvoiceDescriptionIcon"
        @click:prepend='toggleInvoiceDescription'
        :readonly='!withInvoiceDescription'
        hint='You can add an invoice description - something like: "late cancellation"'
        label='Set invoice description' v-model='invoiceDescription' >
      </v-text-field>
      <template v-if='withInvoiceDescription' >
        <v-subheader class='pa-0 overline'>Quick picks</v-subheader>
        <v-chip @click='invoiceDescription="Appointment cancelled"' small>Appointment cancelled</v-chip>
        <v-chip @click='invoiceDescription="Late cancellation"' small>Late cancellation</v-chip>
      </template>
    </v-card-text>
    <v-card-actions>
      <v-btn @click='$emit("close")' flat >close</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary"
        @click='save'
        :loading='response.loading'
        :disabled='!appointment.id' >
        Cancel Appointment
      </v-btn>
      <!-- <vuex-btn
        :is-disabled='!appointment.id'
        :reqId='reqId'
        text='Cancel appointment'
        @save='save'  ></vuex-btn> -->
    </v-card-actions>
    <!-- <v-progress-linear
      v-show='cancelRequest && cancelRequest.loading'
      :indeterminate='true' :height='3' ></v-progress-linear> -->
</v-card>
</template>

<script>
import AppointmentListItem from '../AppointmentListItem'
import RequestsMixin from '@/mixins/requests'

import {ACTIVE_APPOINTMENT_DETAIL} from '@/store/constants'

export default {
  name: 'CancelAppointment',
  mixins: [RequestsMixin],
  components: {AppointmentListItem},
  props: {
    appointment: { type: Object, default: () => { return {} } }
  },
  data () {
    return {
      reqId: 'cancelappointment-save-request',
      withCommunication: true,
      withBookingLink: false,
      clearprice: false,
      price: 0,
      invoiceDescription: '',
      withInvoiceDescription: false,
      response: { status: 0 }
    }
  },
  mounted () {
    if (!this.hasContacts) {
      this.withCommunication = false
    }
  },
  watch: {
    cancelRequestStatus () {
      if (this.cancelRequestStatus === 200) {
        this.$emit('appointmentcancelled', this.cancelRequest)
        this.getAppointmentsInRange()
        this.$emit('close')
      }
    },
    hasContacts () {
      if (!this.hasContacts) {
        this.withCommunication = false
      }
    },
    appointmentId: {
      immediate: true,
      handler () {
        if (this.appointmentId) {
          this.price = this.appointment.price
          this.getAppointment(this.appointmentId)
        }
      }
    }
  },
  computed: {
    payload () {
      if (this.appointmentId) {
        let data = {
          appointments: this.appointmentId.toString(),
          send_notifications: this.withCommunication,
          include_booking_link: this.withBookingLink
        }
        if (this.clearprice) {
          data['price'] = this.price
        }
        if (this.withInvoiceDescription) {
          data['invoice_description'] = this.invoiceDescription
        }
        return data
      }
      return {}
    },
    cancelMessage () {
      let firstName = ''
      if (this.client) {
        firstName = this.client.first_name
      }
      let dt = this.dateformat(this.appointment.start_time)
      let msg = `Hi ${firstName}.%0aYour appointment on ${dt} has been cancelled.`
      if (this.withBookingLink) {
        msg = `${msg}%0a
If you would like to schedule a new appointment, click here:%0a
https://widget.bookme.guru/?p=${this.appointment.practitioner}`
      }
      return msg
    },
    appointmentRequest () {
      return this.$store.getters.getRequestById(ACTIVE_APPOINTMENT_DETAIL, true)
    },
    appointmentDetail () {
      return this.getObjectPath(this.appointmentRequest, 'result.data', {})
    },
    cancelRequestStatus () {
      return this.response.status
    },
    appointmentId () {
      if (this.appointment) {
        return this.appointment.id
      }
    },
    client () {
      return this.getClientById(this.appointment.client)
    },
    sendCommsHint () {
      if (!this.clientHasContacts(this.client)) {
        return 'No contact details found for this client'
      }
    },
    hasContacts () {
      if (this.client) {
        return this.clientHasContacts(this.client)
      }
      return false
    },
    clearpriceIcon () {
      if (this.clearprice) {
        return 'check_box'
      } else {
        return 'check_box_outline_blank'
      }
    },
    withInvoiceDescriptionIcon () {
      if (this.withInvoiceDescription) {
        return 'check_box'
      } else {
        return 'check_box_outline_blank'
      }
    }
  },
  methods: {
    save () {
      this.action(
        this.$appointmentguru,
        'practitioner',
        'appointments',
        false, // this.appointmentId
        'bulk_cancel',
        this.payload,
        this.response
      )
    },
    toggleInvoiceDescription () {
      this.withInvoiceDescription = !this.withInvoiceDescription
      if (!this.withInvoiceDescription) {
        this.invoiceDescription = ''
      }
    },
    toggleClearPrice () {
      this.clearprice = !this.clearprice
      if (!this.clearprice) {
        this.price = this.appointment.price
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Cancel.vue?80842ff0